module.exports = __webpack_public_path__ + "static/media/headset.384bd2b4.svg";